// The /app/v1 contract between the web app and the web backend. zod schemas are the source of
// truth; both sides import the inferred types.
import { z } from "zod";

export * from "./admin.js";
export * from "./files.js";
export * from "./identity.js";
export * from "./labs.js";
export * from "./me.js";

export const ServiceStatus = z.enum(["ok", "down"]);
export type ServiceStatus = z.infer<typeof ServiceStatus>;

export const HealthReport = z.object({
  status: ServiceStatus,
  webApi: z.object({ version: z.string() }),
  database: z.object({ status: ServiceStatus, detail: z.string().optional() }),
  cosmos: z.object({
    status: ServiceStatus,
    detail: z.string().optional(),
    version: z.record(z.string(), z.string()).nullable(),
  }),
});
export type HealthReport = z.infer<typeof HealthReport>;
